import CoreBase from '../../../../services/engines/CoreBase';
import inputRenderer from './InputRenderer';

const _1MB = 1024 * 1024;

class IframeController extends CoreBase {
    _name = 'IframeController';

    /**
     * Parses entry body as JSON.
     * @param {object} entry
     * @returns {object|null}
     */
    parseBody(entry) {
        if (!entry?.body) return null;
        if (new Blob([entry.body]).size > _1MB) return null;
        try { return JSON.parse(entry.body); } catch { return null; }
    }

    /**
     * Renders entry to HTML and sets iframe srcdoc.
     * @param {object} entry
     * @param {HTMLIFrameElement} iframe
     */
    rebuild(entry, iframe) {
        const html = inputRenderer.render(entry);
        if (!html || !iframe) return;
        // console.log('[IframeController] rebuild rk=' + entry?.rk);
        iframe.srcdoc = html;
    }
}

const iframeController = new IframeController();
export default iframeController;
